import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  '@global': {
    '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
      paddingTop: '10px !important',
      paddingBottom: '10px !important',
    },
  },
  tableContainer: {
    width: '100%',
  },
  tabsRow: {
    width: '100%',
  },
  hubspotFields: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    width: '100%',
    minWidth: 0,
  },
  checkBox: {
    color: theme.palette.labraIcon.main,
    marginTop: theme.spacing(1),
    justifySelf: 'center',
  },
  tableCell: {
    background: theme.palette.bg.main,
    zIndex: 4,
  },
  fieldsToMapCell: {
    width: '20%',
    minWidth: '20%',
    maxWidth: '20%',
  },
  fieldTypeCell: {
    width: '10%',
    minWidth: '10%',
    maxWidth: '10%',
  },
  hubspotFieldsTableCell: {
    minWidth: '35%',
    maxWidth: '35%',
  },
  defaultValueCell: {
    minWidth: '25%',
    maxWidth: '25%',
  },
  azureEqualColumn: {
    width: '30%',
    minWidth: '30%',
    maxWidth: '30%',
  },
  customCell: {
    width: '5%',
    minWidth: '5%',
    maxWidth: '5%',
  },
  header: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.description,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    alignSelf: 'center',
  },
  headerWithInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  headerInfoIcon: {
    color: theme.palette.labraText.description,
    alignSelf: 'center',
  },
  fieldsToMapRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  fieldsToMap: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.labraText.tertiary,
    lineHeight: '20px',
    fontStyle: 'normal',
    letterSpacing: '0.25px',
    alignSelf: 'center',
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
  inputText: {
    width: theme.spacing(33.375),
  },
  inputSelect: {
    background: theme.palette.text.white,
    height: 'fit-content',
    alignSelf: 'center',
    borderRadius: theme.spacing(0.5),
    width: '100%',
    minWidth: 0,
  },
  fileUploadBtn: {
    width: theme.spacing(33.375),
    backgroundColor: `${theme.palette.text.white} !important`,
  },
  fileUploadIcon: {
    width: theme.spacing(5),
    backgroundColor: `${theme.palette.text.white} !important`,
  },
  fileUploadContainer: {
    width: '100%',
  },
  selectedFileChipContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: theme.spacing(33.37),
  },
  selectedFileChipInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    minHeight: theme.spacing(6),
    borderRadius: theme.spacing(0.5),
  },
  chipContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  chip: {
    display: 'flex',
    height: theme.spacing(4),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    backgroundColor: '#FFFFFF',
    padding: `${theme.spacing(0.75, 1, 0.75, 1.5)} !important`,
    gap: theme.spacing(1),
    border: 'none',
    '& .MuiChip-label': {
      textAlign: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.tertiary,
      padding: `${theme.spacing(0)} !important`,
    },
    '& .MuiChip-deleteIcon': {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
      color: theme.palette.textField.main,
    },
    '& > span': {
      padding: theme.spacing(0),
    },
  },
  mapButton: {
    backgroundColor: `${theme.palette.text.white} !important`,
  },
}))
